"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeaderCartConfig;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
/**
 * Header Cart wrapper with context
 *
 * @param {Object} props React props
 * @returns {React.ReactElement} React HTML element
 * @public
 */
function HeaderCartConfig(props) {
  const {
    id,
    configKey
  } = props;
  return /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    id: `id-${id}`,
    "data-configkey": configKey
  });
}
HeaderCartConfig.propTypes = {
  id: _propTypes.default.string,
  configKey: _propTypes.default.string
};